import React from "react";
/**
 * The React context object consumers may use to access the context of the
 * portal.
 */
export const PortalContext = /*#__PURE__*/React.createContext({});
PortalContext.displayName = "PortalContext";